import React from 'react';

import ReactDOM from 'react-dom/client';
import './i18n/i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexReactClient } from "convex/react";
import { App } from './App';
import { ConvexErrorBoundary } from './shared/components/ConvexErrorBoundary';

const convex = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL as string);

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY as string;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <ConvexErrorBoundary>
          <App/>
        </ConvexErrorBoundary>
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
